// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"354":"9bca1350","455":"e021a6ef","488":"1a9a8f8c","614":"8859a5e0","685":"729ef1fc","695":"ed2674cb","977":"a3022c91"}[chunkId] + ".chunk.js";
};